import {createStyles} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const PurchaseHistoryDetailStyle = () =>
  createStyles({
    detailTitle: {
      fontSize: 20,
      fontWeight: 700,
      color: 'black',
      marginBottom: 20,
    },
    cardWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 10,
    },
    informationWrapper: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: 10,
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: 'black',
    },
    card: {
      background: 'white',
      borderRadius: '15px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      padding: '25px',
      position: 'relative',
      overflow: 'hidden',
      transform: 'translateY(0)',
      transition: 'all 0.3s ease',

      '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #0cc7c7, #00a8a8)',
      },
    },

    productSection: {
      padding: '10px 0',
      lineHeight: 1.6,
    },

    infoItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '12px',
    },

    bullet: {
      color: '#0cc7c7',
      fontWeight: 'bold',
      marginRight: '8px',
      fontSize: '16px',
      lineHeight: 1.5,
    },

    infoText: {
      color: '#333',
      fontSize: '18px',
    },
    table: {
      position: 'relative',
      color: 'red',
      marginTop: '15px',
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
      marginBottom: 20,
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    headerMax: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
    },
    clickableText: {
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
  })

export default PurchaseHistoryDetailStyle
